export const baseURL = "https://ferrywheel.ls.brtmultisoftware.com/";
export const adminBaseURL = "https://admin.ls.brtmultisoftware.com/";
export const key = "rJ%t}%6V@0}Y$Jz6$0$+!>2d*Sr-H(YR";